import {
  HashRouter as Router,
  Route,
  Switch,
}from 'react-router-dom';

import {
  Home,
  ActHome,
}from './comp';

import 'bootstrap/dist/css/bootstrap.css';
import './css/app.css';

import React, { Component } from 'react';

class App extends Component {
  render() {
    return (
      <div>
        <Links />
        {/*}
        <Navigation />
        */}
        <Routing />
      </div>
    );
  }
}

const Links = (props) => {
  return(
    <link rel="stylesheet" type="text/css" href="https://maxcdn.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css" />
  )
}
/*
let Navigation = (props) => {
  return(
    <Navbar collapseOnSelect style={styles.navigation}>
      <Navbar.Header>
        <Navbar.Brand>
          <a href={PATH.home}>Spelling Dojo App</a>
        </Navbar.Brand>
      </Navbar.Header>
    </Navbar>
  )
}

Navigation = Radium(Navigation);
*/
const Routing = (props) => (
  <Router>
    <Switch>
        {/* No PID Route */}
        <Route
          exact
          path="/"
          component={Home}
        />
        {/* PID Route */}
        <Route
          path="/:pid/:action"
          component={ActHome}
        />
        <Route
          path="/:pid"
          component={ActHome}
        />
        {/* If in activity show activity */}
        <Route
          path="/"
          component={NotFound}
        />
      </Switch>
    </Router>
)


const NotFound = (props) => (<h2>404 NOT FOUND</h2>)

export default App;



// WEBPACK FOOTER //
// ./src/App.js